import styled from "styled-components";

export const TextsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LayoutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const FormContainer = styled.div`
  min-width: 450px;
  max-width: 450px;
`;
